import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceArticlesRoute: InvariantJiraRoute = {
	name: 'csm-experience-articles',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/articles',
	exact: true,
};
